var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M7,4.25V0H.75A.748.748,0,0,0,0,.75v14.5A.748.748,0,0,0,.75,16h10.5a.748.748,0,0,0,.75-.75V5H7.75A.752.752,0,0,1,7,4.25Zm2,7.375A.376.376,0,0,1,8.625,12H3.375A.376.376,0,0,1,3,11.625v-.25A.376.376,0,0,1,3.375,11h5.25A.376.376,0,0,1,9,11.375Zm0-2A.376.376,0,0,1,8.625,10H3.375A.376.376,0,0,1,3,9.625v-.25A.376.376,0,0,1,3.375,9h5.25A.376.376,0,0,1,9,9.375Zm0-2.25v.25A.376.376,0,0,1,8.625,8H3.375A.376.376,0,0,1,3,7.625v-.25A.376.376,0,0,1,3.375,7h5.25A.376.376,0,0,1,9,7.375Zm3-3.566V4H8V0h.191a.749.749,0,0,1,.531.219l3.059,3.063A.748.748,0,0,1,12,3.809Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFileIcon);
export default __webpack_public_path__ + "static/media/dashboard-file-icon.f0671a15248c5a5bbd44b3a8368270b1.svg";
export { ForwardRef as ReactComponent };